module.exports = __webpack_public_path__ + "static/media/momo3.412d0501.jpg";